import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface Props {
    error?: boolean
    helperText?: string
    onChange: (value: any) => void;
    defaultValue: Dayjs;
    value?: Dayjs | null;
    width?: string
}
const DateTimePickerCommon = (props: Props) => {
    const {error, helperText, onChange, defaultValue, value, width} = props;
    const initialValue = dayjs(defaultValue).isValid()
    ? dayjs(defaultValue)
    : dayjs(new Date());

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        className="w-[100%] h-[40px] !font-forza"
        sx={{
          with: `${width}`,
          "& div.MuiInputBase-root": {
            height: "40px",
          },
          "& .MuiFormHelperText-root": {
            fontFamily: "forza",
            marginLeft: 0,
            marginTop: 0,
            color: "red",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: `${error ? "red!important" : ""}`,
          },
        }}
        defaultValue={initialValue}
        value={value}
        onChange={onChange}
        format="YYYY-MM-DD HH:mm"
        ampm={false}
        slotProps={{
          textField: {
            helperText: helperText,
          },
        }}
      />
    </LocalizationProvider>
  );
};
export default DateTimePickerCommon;
